// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as ClientOptions, TDataShape } from '@hey-api/client-fetch';
import { client as _heyApiClient } from '../client';
import type {
  ModelTrialCasesListOnlineData,
  ModelTrialCasesListOnlineError,
  ModelTrialCasesListOnlineResponse,
} from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = ClientOptions<
  TData,
  ThrowOnError
> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>;
};

/**
 * Public read of online cases for the exact form/model in this deployment's database.
 * zh/en match exactly; other languages fall back to each case's English content when missing.
 */
export const modelTrialCasesListOnline = <ThrowOnError extends boolean = false>(
  options?: Options<ModelTrialCasesListOnlineData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    ModelTrialCasesListOnlineResponse,
    ModelTrialCasesListOnlineError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/vidu/v1/model-trial-cases',
    ...options,
  });
};
